import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "篩檢年份",
    isNumber: true,
    isSum: true,
  },
];

export const ADLTotalScoreToCheckYear = {
  label: "ADL總分 vs 篩檢年份",
  key: "ADLTotalScoreToCheckYear",
  path: "ElderlyHealth/ADLTotalScoreToCheckYear",
  api: "TCS_V_OHCheckItems01V",
  render: (options) => (
    <Diagram.ElderlyHealth.ADLTotalScoreToCheckYear {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "ADL",
      field: "ADL",
      header: "",
      isNumber: true,
      isSkip: true,
    },
  ],
  levelColumns,
  columns: [],
};
